// extracted by mini-css-extract-plugin
export default {"activeLink":"MainLayout_activeLink__hSyWw","link":"MainLayout_link__Yk7UF","active":"MainLayout_active__n7lVM"};